import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { DsBadge } from '@frontend/ui/badge';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-acca-boost-logo',
    templateUrl: './acca-boost-logo.component.html',
    styleUrl: './acca-boost-logo.component.scss',
    standalone: true,
    imports: [DsBadge, IconCustomComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccaBoostLogoComponent {
    accaBoostRewardTitle = input<string>();
    showInfoIcon = input<boolean>(false);
    clickInfoEvent = output<void>();
    readonly accaBoostInfoIconSize = '12';

    onClickInfo() {
        this.clickInfoEvent.emit();
    }
}
